import { COPY } from '@/lib/copy';

type Props = {
  open: boolean;
  onClick: () => void;
};

export default function HamburgerButton({ open, onClick }: Props) {
  return (
    <button
      className="tablet:hidden relative z-[95] flex flex-col gap-[5px] p-1 bg-transparent border-none cursor-pointer"
      onClick={onClick}
      aria-label={open ? COPY.nav.closeMenu : COPY.nav.openMenu}
      aria-expanded={open}
      aria-controls="nav-mobile"
    >
      <span
        className={`block w-[22px] h-[2px] bg-text transition-transform duration-300 origin-center ${open ? 'translate-y-[7px] rotate-45' : ''}`}
      />
      <span
        className={`block w-[22px] h-[2px] bg-text transition-opacity duration-300 ${open ? 'opacity-0' : ''}`}
      />
      <span
        className={`block w-[22px] h-[2px] bg-text transition-transform duration-300 origin-center ${open ? '-translate-y-[7px] -rotate-45' : ''}`}
      />
    </button>
  );
}
